import { siteGet, siteSave, DelSite, GetScene, SaveScene } from '@/api/site'
export default {
  state: {

  },
  actions: {
    getSite ({ commit }, payload) {
      return new Promise(resolve => {
        siteGet(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    saveSite ({ commit }, payload) {
      return new Promise(resolve => {
        siteSave(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    DelSite ({ commit }, payload) {
      return new Promise(resolve => {
        DelSite(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    GetScene({commit},payload){
      return new Promise(resolve => {
        GetScene(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SaveScene({commit},payload){
      return new Promise(resolve => {
        SaveScene(payload).then(res => {
          resolve(res.data)
        })
      })
    },

  },
  getters: {

  },
  mutations: {

  }
}
